import {CallHistoryDirection} from '@pexip/media-components';
import type {CallHistoryRecentItem} from '@pexip/media-components';
import type {Incoming} from '@pexip/infinity';

interface BaseCallRecentParams {
    conferenceAlias: string;
    serviceType?: string;
    incomingCall?: Incoming;
}

interface CallRecentParams extends BaseCallRecentParams {
    succeeded: boolean;
    conferenceName?: string;
}

interface MissedCallRecentParams {
    incomingCall: Incoming;
    node: string;
}

const getMissedCallMeetingId = (incomingCall: Incoming, node: string) => {
    if (
        incomingCall.service_type === 'conference' &&
        !incomingCall.remote_alias.includes('@')
    ) {
        return `${incomingCall.remote_alias}@${node}`;
    }
    return incomingCall.remote_alias;
};

export const toCallRecent = ({
    succeeded,
    conferenceName,
    conferenceAlias,
    serviceType,
    incomingCall,
}: CallRecentParams): CallHistoryRecentItem => {
    const isConference = serviceType === 'conference';
    const title =
        incomingCall?.remote_display_name ||
        (serviceType !== 'gateway' ? conferenceName : undefined);
    const meetingId =
        incomingCall && !isConference
            ? incomingCall.remote_alias
            : conferenceAlias;

    return {
        title,
        meetingId,
        direction: incomingCall
            ? CallHistoryDirection.Incoming
            : CallHistoryDirection.Outgoing,
        dateAndTime: new Date().toISOString(),
        succeeded,
        isExpired: !!incomingCall && incomingCall.callback_available === false,
    };
};

export const toMissedCallRecent = ({
    incomingCall,
    node,
}: MissedCallRecentParams): CallHistoryRecentItem => ({
    meetingId: getMissedCallMeetingId(incomingCall, node),
    title: incomingCall.remote_display_name,
    direction: CallHistoryDirection.Missed,
    dateAndTime: new Date().toISOString(),
    succeeded: false,
});
